import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BranchMatserService } from '../branch-matser.service';
import { BranchMaster } from '../models/branch-master.model';

@Component({
  selector: 'app-search-branch-master',
  templateUrl: './search-branch-master.component.html',
  styleUrls: ['./search-branch-master.component.scss']
})
export class SearchBranchMasterComponent implements OnInit {
  dataSource = new MatTableDataSource<BranchMaster>();
  selection = new SelectionModel<any>(true, []);
  searchText: string = '';
  searchBranchlimaster:any;
  originalData: any[] = [];
  displayedColumns: string[] = ['companyName','branchName', 'branchCode', 'address', 'contactPerson',
    'contactNo', 'emailAddress', 'faxNo', 'line1', 'line2', 'line3', 'line4',
    'dlno', 'tinno', 'imageLogo', 'isActive',   'isNabhLogo', 'isHeaderImage', 'headerImageHeight',
    'headerImageWidth', 'gstNo',   'panNo', 'isCentralOpticStore'];
  constructor(public dialog: MatDialog, public branchMasterService: BranchMatserService) { }

  ngOnInit(): void {
    this.branchMasterService.selecteBranchMasterData = null;
    this.getBrachMasterList();
  }
  getBrachMasterList() {
    this.branchMasterService.getBrachMasterList().subscribe(data => {
       this.originalData = data;
      this.dataSource.data = data
    })
    // console.log();
  }

  closedialog() {
    this.dialog.closeAll();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.branchMasterService.selecteBranchMasterData = row;
    console.log(this.branchMasterService.selecteBranchMasterData);
    this.dialog.closeAll();
  }

onSearchbranch(searchTerm: string) {
  const lowerSearchTerm = searchTerm.toLowerCase();

 const dataArray = this.originalData;

  if (!lowerSearchTerm) {
    this.dataSource.data = this.originalData;
    return;
  }
  const exactMatches = dataArray
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (item.companyName && item.companyName.toLowerCase() === lowerSearchTerm) ||
      (item.branchName && item.branchName.toLowerCase() === lowerSearchTerm) ||
      (item.branchCode && item.branchCode.toLowerCase() === lowerSearchTerm) || 
      (item.address && item.address.toLowerCase() === lowerSearchTerm) ||
      (item.contactPerson && item.contactPerson.toLowerCase() === lowerSearchTerm) || 
       (item.contactNo && item.contactNo.toLowerCase() === lowerSearchTerm) ||
      (item.emailAddress && item.emailAddress.toLowerCase() === lowerSearchTerm) ||
      (item.faxNo && item.faxNo.toLowerCase() === lowerSearchTerm) || 
      (item.gstNo && item.gstNo.toLowerCase() === lowerSearchTerm) ||
      (item.line1 && item.line1.toLowerCase() === lowerSearchTerm) || 
       (item.line2 && item.line2.toLowerCase() === lowerSearchTerm) ||
      (item.line3 && item.line3.toLowerCase() === lowerSearchTerm) ||
      (item.line4 && item.line4.toLowerCase() === lowerSearchTerm) || 
      (item.dlno && item.dlno.toLowerCase() === lowerSearchTerm) ||
      (item.tinno && item.tinno.toLowerCase() === lowerSearchTerm) || 
       (item.imageLogo && item.imageLogo.toLowerCase() === lowerSearchTerm) ||
      (item.headerImageWidth != null && item.headerImageWidth.toString() === lowerSearchTerm) ||
      (item.headerImageHeight != null && item.headerImageHeight.toString() === lowerSearchTerm) || 
      (item.panNo && item.panNo.toLowerCase() === lowerSearchTerm) ||
      (item.isCentralOpticStore && item.isCentralOpticStore.toLowerCase() === lowerSearchTerm)
    );

  const partialMatches = dataArray
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (
        (item.companyName && item.companyName.toLowerCase().includes(lowerSearchTerm)) ||
        (item.branchName && item.branchName.toLowerCase().includes(lowerSearchTerm)) ||
        (item.branchCode && item.branchCode.toLowerCase().includes(lowerSearchTerm)) ||
        (item.address && item.address.toLowerCase().includes(lowerSearchTerm)) ||
        (item.contactPerson && item.contactPerson.toLowerCase().includes(lowerSearchTerm))||
        (item.contactNo && item.contactNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.emailAddress && item.emailAddress.toLowerCase().includes(lowerSearchTerm)) ||
        (item.faxNo && item.faxNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.gstNo && item.gstNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.line1 && item.line1.toLowerCase().includes(lowerSearchTerm)) || 
        (item.line2 && item.line2.toLowerCase().includes(lowerSearchTerm)) ||
        (item.line3 && item.line3.toLowerCase().includes(lowerSearchTerm)) ||
        (item.line4 && item.line4.toLowerCase().includes(lowerSearchTerm)) ||
        (item.dlno && item.dlno.toLowerCase().includes(lowerSearchTerm)) ||
        (item.tinno && item.tinno.toLowerCase().includes(lowerSearchTerm)) || 
         (item.imageLogo && item.imageLogo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.headerImageWidth != null && item.headerImageWidth.toString().includes(lowerSearchTerm)) ||
      (item.headerImageHeight != null && item.headerImageHeight.toString().includes(lowerSearchTerm)) ||
        (item.panNo && item.panNo.toLowerCase().includes(lowerSearchTerm)) ||
        (item.isCentralOpticStore && item.isCentralOpticStore.toLowerCase().includes(lowerSearchTerm))
      ) &&
      !exactMatches.find(m => m._originalIndex === item._originalIndex)
    );
  this.dataSource.data = [...exactMatches, ...partialMatches];
}
}